import React, { useEffect, useState } from 'react';
import { StylesConfig } from 'react-select';
import makeAnimated from 'react-select/animated';
import Select from 'react-select';

interface DropdownOption<T = any> {
  [key: string]: any;
}

interface SearchableDropdownProps<T = any> {
  listInputs: T[];
  label: string;
  inputName: string;
  value: string;
  handleOnChange(e: any): void;
  editableTitle?: JSX.Element;
  valueKey: keyof T;
  displayKey: keyof T;
  isClearable?: boolean;
  placeholder?: string;
  className?: string;
}

function SearchableDropDownStringOptionAndValue<T>({
  listInputs,
  label,
  inputName,
  value,
  handleOnChange,
  editableTitle,
  valueKey,
  displayKey,
  isClearable = true,
  placeholder = 'Select',
  className = ''
}: SearchableDropdownProps<T>) {
  const [selectedOption, setSelectedOption] = useState<any>(null);

  const options = listInputs.map((item) => ({
    value: String(item[valueKey]),
    label: String(item[displayKey])
  }));

  useEffect(() => {
    const found = options.find((opt) => opt.value === value);
    setSelectedOption(found ?? null);
  }, [value, options]);

  const onChange = (selected: any) => {
    setSelectedOption(selected);
    handleOnChange({
      target: {
        name: inputName,
        value: selected ? selected.value : '',
      },
    });
  };

  const animatedComponents = makeAnimated();

  const customStyles: StylesConfig<any, false> = {
    control: (base) => ({ ...base, minHeight: 40 }),
    menu: (base) => ({ ...base, zIndex: 999 }),
    placeholder: (base) => ({
      ...base,
      fontFamily: 'Arial, sans-serif',
      fontStyle: 'italic',
      color: '#D9D7D4',
    }),
  };

  return (
    <div className={`form-group ${className}`}>
      {editableTitle ? (
        <label className="control-label">{editableTitle}</label>
      ) : (
        <label className="control-label">{label}</label>
      )}

      <Select
        options={options}
        value={selectedOption}
        onChange={onChange}
        placeholder={placeholder}
        isClearable={isClearable}
        name={inputName}
        styles={customStyles}
        components={animatedComponents}
      />
    </div>
  );
}

export default SearchableDropDownStringOptionAndValue;
